document.addEventListener('DOMContentLoaded', function() {
  // Manejar clicks en los enlaces de popup
  document.querySelectorAll('.feature-item__popup-link').forEach(function(link) {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      const popupId = this.getAttribute('data-popup-id');
      const popup = document.getElementById(popupId);
      
      if (popup) {
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        popup.focus();
      }
    });
  });
  
  // Manejar cierre de popups
  document.querySelectorAll('.feature-popup__close').forEach(function(closeBtn) {
    closeBtn.addEventListener('click', function() {
      const popup = this.closest('.feature-popup');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    });
  });
  
  // Cerrar al hacer click fuera del contenido
  document.querySelectorAll('.feature-popup').forEach(function(popup) {
    popup.addEventListener('click', function(e) {
      if (e.target === this) {
        this.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    });
  });
  
  // Cerrar con tecla ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.feature-popup[aria-hidden="false"]').forEach(function(popup) {
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      });
    }
  });

  // Manejar clicks en los items con enlace a producto
  document.querySelectorAll('.feature-item[data-product-handle]').forEach(function(item) {
    item.addEventListener('click', function(e) {
      // Solo redirigir si no se hizo click en un elemento interactivo
      if (!e.target.closest('a, button, [onclick]')) {
        const productHandle = this.getAttribute('data-product-handle');
        window.location = '/products/' + productHandle;
      }
    });
    
    // Cambiar cursor para indicar que es clickeable
    item.style.cursor = 'pointer';
  });
});